<template>
  <a-config-provider :locale="antdLocale">
    <global-layout @dynamicRouterShow="dynamicRouterShow">
      <!-- update-begin- author:sunjianlei --- date:20191009 --- for: 提升右键菜单的层级 -->
      <contextmenu :itemList="menuItemList" :visible.sync="menuVisible" style="z-index: 9999;" @select="onMenuSelect"/>
      <!-- update-end- author:sunjianlei --- date:20191009 --- for: 提升右键菜单的层级 -->
      <a-tabs
        @contextmenu.native="e => onContextmenu(e)"
        v-if="multipage"
        :active-key="activePage"
        class="tab-layout-tabs"
        style="height:52px"
        :hide-add="true"
        type="editable-card"
        @change="changePage"
        @tabClick="tabCallBack"
        @edit="editPage">
        <a-tab-pane :id="page.fullPath" :key="page.fullPath" v-for="page in pageList">
          <span slot="tab" :pagekey="page.fullPath" v-if="page.query&&page.query.metaTitle">{{ $menuTitle(page.query.metaTitle) }}</span>
          <span slot="tab" :pagekey="page.fullPath" v-else>{{ $menuTitle(page.meta.title) }}</span>
        </a-tab-pane>
      </a-tabs>
      <div style="margin: 12px 12px 0;" :style="{ height: $store.state.user.layoutTree?'calc(100vh - 192px)':'91%',overflow: $store.state.user.layoutTree?'hidden':'initial'}">
        <transition name="page-toggle">
          <keep-alive v-if="multipage">
            <router-view v-if="reloadFlag"/>
          </keep-alive>
          <template v-else>
            <router-view v-if="reloadFlag"/>
          </template>
        </transition>
      </div>
    </global-layout>
  </a-config-provider>
</template>

<script>
  import GlobalLayout from '@/components/page/GlobalLayout'
  import Contextmenu from '@/components/menu/Contextmenu'
  import { mixin, mixinDevice } from '@/utils/mixin.js'
  import { triggerWindowResizeEvent } from '@/utils/util'
  import { mapGetters } from 'vuex'
  import { getAntdLocale } from '@/i18n'

  const indexKey = '/dashboard/analysis'
  const indexMaintenanceKey = '/websiteMonitoring/MeterDeviceBaseList'
  const indexwaterQualityKey = '/waterMonitoring/WQDeviceList'
  const indexengineeringInstallationKey = '/engineeringInstallation/home'
  const indexworkOrderManagementKey = '/workOrderManagement/home'
  const indexinspectionManagementKey = '/inspectionManagement/home'
  const indexOAofficeKey = '/account/settings/Workplace'
  const indexHotlineKey = '/hotline/AttendantConsole/index'
  // const indexDMAKey = '/DMAPartitionMetering/PipelineManagement/overview'
  const indexDMAKey = '/DMAPartitionMetering/PipelineNew/ComprehensiveDisplay'
  const indexNoticeKey = '/meterUseWarnManagement/meterUseWarnConfigList'
  // const indexMeterManagementKey = '/meterManagement/meterUserInfoList'
  const indexMeterManagementKey = '/meterManagement/meterinfoList'
  const indexCollectKey = '/InternetDeviceManagement/MeterUpDataList'

  export default {
    name: 'TabLayout',
    components: {
      GlobalLayout,
      Contextmenu
    },
    mixins: [mixin, mixinDevice],
    data() {
      return {
        pageList: [],
        linkList: [],
        activePage: '',
        menuVisible: false,
        reloadFlag:true
      }
    },
    /* update_begin author:wuxianquan date:20190828 for: 关闭当前tab页，供子页面调用 ->望菜单能配置外链，直接弹出新页面而不是嵌入iframe #428 */
    // 注：provide 与文件尾部 provide(>onBackNeeds) 已合并为一处（JS 对象重复键后者覆盖前者，曾导致 closeCurrent 失效）
    /* update_end author:wuxianquan date:20190828 for: 关闭当前tab页，供子页面调用->望菜单能配置外链，直接弹出新页面而不是嵌入iframe #428 */
    computed: {
      // Ant Design Vue 内部文案（分页/日期选择/弹窗默认按钮等）随语言切换
      antdLocale() {
        return getAntdLocale(this.$store.state.app.language)
      },
      menuItemList() {
        return [
          { key: '4', icon: 'reload', text: this.$t('刷 新') },
          { key: '1', icon: 'arrow-left', text: this.$t('关闭左侧') },
          { key: '2', icon: 'arrow-right', text: this.$t('关闭右侧') },
          { key: '3', icon: 'close', text: this.$t('关闭其它') }
        ]
      },
      multipage() {
        //判断如果是手机模式，自动切换为单页面模式
        if (this.isMobile()) {
          return false
        } else {
          return this.$store.state.app.multipage
        }
      },
      ...mapGetters([
        'sysType'
      ])
    },
    created() {
      if (![indexKey,indexwaterQualityKey,indexMaintenanceKey,indexengineeringInstallationKey,indexworkOrderManagementKey,indexinspectionManagementKey,indexOAofficeKey,indexHotlineKey,indexDMAKey,indexNoticeKey,indexMeterManagementKey,indexCollectKey].includes(this.$route.path)) {
        // console.error(this.sysType)
        this.addIndexToFirstBySystem()
      }
      
      
      // update-begin-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
      let storeKey = 'route:title:' + this.$route.fullPath
      let routeTitle = this.$ls.get(storeKey)
      if (routeTitle) {
        this.$route.meta.title = routeTitle
      }
      // update-end-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
      this.pageList.push(this.$route)
      this.linkList.push(this.$route.fullPath)
      this.activePage = this.$route.fullPath
    },
    mounted() {
    },
    watch: {
      '$route': function(newRoute) {
        //console.log("新的路由",newRoute)
        this.activePage = newRoute.fullPath
        if (!this.multipage) {
          this.linkList = [newRoute.fullPath]
          this.pageList = [Object.assign({},newRoute)]
        // update-begin-author:taoyan date:20200211 for: TASK #3368 【路由缓存】首页的缓存设置有问题，需要根据后台的路由配置来实现是否缓存
        } else if([indexKey,indexwaterQualityKey,indexMaintenanceKey,indexengineeringInstallationKey,indexworkOrderManagementKey,indexinspectionManagementKey,indexOAofficeKey,indexHotlineKey,indexDMAKey,indexNoticeKey,indexMeterManagementKey,indexCollectKey].includes(newRoute.fullPath)) {
          //首页时 判断是否缓存 没有缓存 刷新之
          if (newRoute.meta.keepAlive === false) {
            this.routeReload()
          }
        // update-end-author:taoyan date:20200211 for: TASK #3368 【路由缓存】首页的缓存设置有问题，需要根据后台的路由配置来实现是否缓存
        }else if (this.linkList.indexOf(newRoute.fullPath) < 0) {
          // this.linkList.push(newRoute.fullPath)
          // this.pageList.push(Object.assign({},newRoute))
          
          // 新加逻辑(解决路由tab重复问题)
          let index = this.pageList.findIndex(item => item.path === newRoute.path);
          if(index!=-1){
            this.linkList[index] = newRoute.fullPath;
            this.pageList[index] = Object.assign({},newRoute)
          }else{
            this.linkList.push(newRoute.fullPath)
            this.pageList.push(Object.assign({},newRoute))
          }
          // this.routeReload()
          // update-begin-author:sunjianlei date:20200103 for: 如果新增的页面配置了缓存路由，那么就强制刷新一遍
          if (newRoute.meta.keepAlive !== true) {
            // update-begin-author:xiaoma date:20200813 for:因为强制刷新的原因，之前还存的也在再次打开时，会重新执行一遍create生命周期
            this.routeReload()
            // update-begin-author:xiaoma date:20200813
          }
          // update-end-author:sunjianlei date:20200103 for: 如果新增的页面配置了缓存路由，那么就强制刷新一遍
        } else if (this.linkList.indexOf(newRoute.fullPath) >= 0) {
          let oldIndex = this.linkList.indexOf(newRoute.fullPath)
          let oldPositionRoute = this.pageList[oldIndex]
          this.pageList.splice(oldIndex, 1, Object.assign({},newRoute,{meta:oldPositionRoute.meta}))
        }
      },
      'activePage': function(key) {
        this.$store.commit('SET_LAYOUT_TREE', false)
        let index = this.linkList.lastIndexOf(key)
        let waitRouter = this.pageList[index]
        this.$router.push(Object.assign({},waitRouter));
        this.changeTitle(waitRouter.meta.title)
      },
      'multipage': function(newVal) {
        if(this.reloadFlag){
          if (!newVal) {
            this.linkList = [this.$route.fullPath]
            this.pageList = [this.$route]
          }
        }
      },
      // update-begin-author:sunjianlei date:20191223 for: 修复从单页模式切换回多页模式后首页不居第一位的 BUG
      device() {
        if (this.multipage&&this.linkList.indexOf(key) === -1) {
          this.addIndexToFirstBySystem()
        }
      },
      // update-end-author:sunjianlei date:20191223 for: 修复从单页模式切换回多页模式后首页不居第一位的 BUG
      'sysType':function(val) {
        // this.pageList.splice(this.pageList.length-1,1);
        console.error("监听到sysType变化")
        this.addIndexToFirstBySystem()
      }
    },
    methods: {
      // update-begin-author:sunjianlei date:20191223 for: 修复从单页模式切换回多页模式后首页不居第一位的 BUG
      // 将首页添加到第一位
      addIndexToFirst() {
        this.pageList.splice(0, 0, {
          name: 'dashboard-analysis',
          path: indexKey,
          fullPath: indexKey,
          meta: {
            icon: 'dashboard',
            title: '首页'
          }
        })
        this.linkList.splice(0, 0, indexKey)
      },
      addIndexWaterQualityToFirst() {
        this.pageList.splice(0, 0, {
          name: 'wq-device-list',
          path: indexMaintenanceKey,
          fullPath: indexMaintenanceKey,
          meta: {
            icon: '',
            title: '设备管理'
          }
        })
        this.linkList.splice(0, 0, indexwaterQualityKey)
      },
      addIndexMaintenanceToFirst() {
        this.pageList.splice(0, 0, {
          name: 'battery-voltage-list',
          path: indexMaintenanceKey,
          fullPath: indexMaintenanceKey,
          meta: {
            icon: '',
            title: '电池电压分析'
          }
        })
        this.linkList.splice(0, 0, indexMaintenanceKey)
      },
      addIndexEngineeringInstallationToFirst() {
        this.pageList.splice(0, 0, {
          name: 'engineeringInstallation-home',
          path: indexengineeringInstallationKey,
          fullPath: indexengineeringInstallationKey,
          meta: {
            icon: '',
            title: '首页'
          }
        })
        this.linkList.splice(0, 0, indexengineeringInstallationKey)
      },
      addIndexWorkOrderManagementToFirst() {
        this.pageList.splice(0, 0, {
          name: 'workOrderManagement-home',
          path: indexworkOrderManagementKey,
          fullPath: indexworkOrderManagementKey,
          meta: {
            icon: '',
            title: '工单申请'
          }
        })
        this.linkList.splice(0, 0, indexworkOrderManagementKey)
      },
      addIndexInspectionManagementToFirst() {
        this.pageList.splice(0, 0, {
          name: 'inspectionManagement-home',
          path: indexinspectionManagementKey,
          fullPath: indexinspectionManagementKey,
          meta: {
            icon: '',
            title: '首页'
          }
        })
        this.linkList.splice(0, 0, indexinspectionManagementKey)
      },
      addIndexOAofficeToFirst() {
        this.pageList.splice(0, 0, {
          name: 'oa-home',
          path: indexOAofficeKey,
          fullPath: indexOAofficeKey,
          meta: {
            icon: '',
            title: '工作台'
          }
        })
        this.linkList.splice(0, 0, indexOAofficeKey)
      },
      addIndexHotlineToFirst() {
        this.pageList.splice(0, 0, {
          name: 'AttendantConsoleIndex',
          path: indexHotlineKey,
          fullPath: indexHotlineKey,
          meta: {
            icon: '',
            title: '话务台'
          }
        })
        this.linkList.splice(0, 0, indexHotlineKey)
      },
      addIndexDMAToFirst() {
        this.pageList.splice(0, 0, {
          name: 'DMAIndex',
          path: indexDMAKey,
          fullPath: indexDMAKey,
          meta: {
            icon: '',
            title: '综合展示'
          }
        })
        this.linkList.splice(0, 0, indexDMAKey)
      },
      addIndexNoticeToFirst(){
        this.pageList.splice(0, 0, {
          name: 'NoticeIndex',
          path: indexNoticeKey,
          fullPath: indexNoticeKey,
          meta: {
            icon: '',
            title: '通知中心'
          }
        })
        this.linkList.splice(0, 0, indexNoticeKey)
      },
      addIndexMeterManagementToFirst(){
        this.pageList.splice(0, 0, {
          name: 'MeterManagementIndex',
          path: indexMeterManagementKey,
          fullPath: indexMeterManagementKey,
          meta: {
            icon: '',
            title: '表务管理'
          }
        })
        this.linkList.splice(0, 0, indexMeterManagementKey)
      },
      addIndexCollectToFirst(){
        this.pageList.splice(0, 0, {
          name: 'CollectIndex',
          path: indexCollectKey,
          fullPath: indexCollectKey,
          meta: {
            icon: '',
            title: '集中抄表'
          }
        })
        this.linkList.splice(0, 0, indexCollectKey)
      },
      // update-end-author:sunjianlei date:20191223 for: 修复从单页模式切换回多页模式后首页不居第一位的 BUG

      // update-begin-author:sunjianlei date:20200120 for: 动态更改页面标题
      changeTitle(title) {
        let projectTitle = this.$t('智慧水务管理平台')
        let menuTitle = this.$menuTitle(title)
        // 首页特殊处理
        if (this.$route.path === indexKey) {
          document.title = projectTitle
        } else {
          document.title = menuTitle + ' · ' + projectTitle
        }
      },
      // update-end-author:sunjianlei date:20200120 for: 动态更改页面标题

      changePage(key) {
        this.activePage = key
      },
      tabCallBack() {
        this.$nextTick(() => {
          triggerWindowResizeEvent()
        })
      },
      editPage(key, action) {
        this[action](key)
      },
      remove(key,type) {
        if ([indexKey,indexwaterQualityKey,indexMaintenanceKey,indexengineeringInstallationKey,indexworkOrderManagementKey,indexinspectionManagementKey,indexOAofficeKey,indexHotlineKey,indexDMAKey,indexNoticeKey,indexMeterManagementKey,indexCollectKey].includes(key)) {
          this.$message.warning(this.$t('首页不能关闭!'))
          return
        }
        if (this.pageList.length === 1) {
          this.$message.warning(this.$t('这是最后一页，不能再关闭了啦'))
          return
        }
        console.log("this.pageList ",this.pageList );
        if(type){// 解决OA关闭流程申请后跳转上一界面
          this.pageList = this.pageList.filter(item => item.fullPath !== key)
          let index = this.linkList.indexOf(type)
          this.linkList = this.linkList.filter(item => item !== key)
          this.activePage = this.linkList[index]
        }else{
          this.pageList = this.pageList.filter(item => item.fullPath !== key)
          let index = this.linkList.indexOf(key)
          this.linkList = this.linkList.filter(item => item !== key)
          index = index >= this.linkList.length ? this.linkList.length - 1 : index
          this.activePage = this.linkList[index]
        }
      },
      onContextmenu(e) {
        const pagekey = this.getPageKey(e.target)
        if (pagekey !== null) {
          e.preventDefault()
          this.menuVisible = true
        }
      },
      getPageKey(target, depth) {
        depth = depth || 0
        if (depth > 2) {
          return null
        }
        let pageKey = target.getAttribute('pagekey')
        pageKey = pageKey || (target.previousElementSibling ? target.previousElementSibling.getAttribute('pagekey') : null)
        return pageKey || (target.firstElementChild ? this.getPageKey(target.firstElementChild, ++depth) : null)
      },
      onMenuSelect(key, target) {
        let pageKey = this.getPageKey(target)
        switch (key) {
          case '1':
            this.closeLeft(pageKey)
            break
          case '2':
            this.closeRight(pageKey)
            break
          case '3':
            this.closeOthers(pageKey)
            break
          case '4':
            this.routeReload()
            break
          default:
            break
        }
      },
      /* update_begin author:wuxianquan date:20190828 for: 关闭当前tab页，供子页面调用->望菜单能配置外链，直接弹出新页面而不是嵌入iframe #428 */
      closeCurrent(){
        this.remove(this.activePage);
      },
      /* update_end author:wuxianquan date:20190828 for: 关闭当前tab页，供子页面调用->望菜单能配置外链，直接弹出新页面而不是嵌入iframe #428 */
      closeOthers(pageKey) {
        let index = this.linkList.indexOf(pageKey)
        if ([indexKey,indexwaterQualityKey,indexMaintenanceKey,indexengineeringInstallationKey,indexworkOrderManagementKey,indexinspectionManagementKey,indexOAofficeKey,indexHotlineKey,indexDMAKey,indexNoticeKey,indexMeterManagementKey,indexCollectKey].includes(pageKey) || pageKey.indexOf('?ticke=')>=0) {
          this.linkList = this.linkList.slice(index, index + 1)
          this.pageList = this.pageList.slice(index, index + 1)
          this.activePage = this.linkList[0]
        } else {
          let indexContent = this.pageList.slice(0, 1)[0]
          this.linkList = this.linkList.slice(index, index + 1)
          this.pageList = this.pageList.slice(index, index + 1)
          this.linkList.unshift(indexContent.fullPath)
          this.pageList.unshift(indexContent)
          this.activePage = this.linkList[1]
        }
      },
      closeLeft(pageKey) {
        if ([indexKey,indexwaterQualityKey,indexMaintenanceKey,indexengineeringInstallationKey,indexworkOrderManagementKey,indexinspectionManagementKey,indexOAofficeKey,indexHotlineKey,indexDMAKey,indexNoticeKey,indexMeterManagementKey,indexCollectKey].includes(pageKey)) {
          return
        }
        let tempList = [...this.pageList]
        let indexContent = tempList.slice(0, 1)[0]
        let index = this.linkList.indexOf(pageKey)
        this.linkList = this.linkList.slice(index)
        this.pageList = this.pageList.slice(index)
        this.linkList.unshift(indexContent.fullPath)
        this.pageList.unshift(indexContent)
        if (this.linkList.indexOf(this.activePage) < 0) {
          this.activePage = this.linkList[0]
        }
      },
      closeRight(pageKey) {
        let index = this.linkList.indexOf(pageKey)
        this.linkList = this.linkList.slice(0, index + 1)
        this.pageList = this.pageList.slice(0, index + 1)
        if (this.linkList.indexOf(this.activePage < 0)) {
          this.activePage = this.linkList[this.linkList.length - 1]
        }
      },
      //update-begin-author:taoyan date:20190430 for:动态路由title显示配置的菜单title而不是其对应路由的title
      dynamicRouterShow(key,title){
        let keyIndex = this.linkList.indexOf(key)
        if(keyIndex>=0){
          let currRouter = this.pageList[keyIndex]
          let meta = Object.assign({},currRouter.meta,{title:title})
          this.pageList.splice(keyIndex, 1, Object.assign({},currRouter,{meta:meta}))
          if (key === this.activePage) {
            this.changeTitle(title)
          }
        }
      },
      //update-end-author:taoyan date:20190430 for:动态路由title显示配置的菜单title而不是其对应路由的title

      //update-begin-author:taoyan date:20191008 for:路由刷新
      routeReload(){
        this.reloadFlag = false
        let ToggleMultipage = "ToggleMultipage"
        this.$store.dispatch(ToggleMultipage,false)
        this.$nextTick(()=>{
          this.$store.dispatch(ToggleMultipage,true)
          this.reloadFlag = true
        })
      },
      //update-end-author:taoyan date:20191008 for:路由刷新
      addIndexToFirstBySystem() {
        if(this.sysType == 2) {
          // 水质监测
          this.addIndexWaterQualityToFirst()
        }else if(this.sysType == 3) {
          // 运维管理
          this.addIndexMaintenanceToFirst()
        }else if(this.sysType == 7){
          // 工程报装
          this.addIndexEngineeringInstallationToFirst()
        }else if(this.sysType == 8){
          // 工单管理
          this.addIndexWorkOrderManagementToFirst()
        }else if(this.sysType == 9){
          // 巡检管理
          this.addIndexInspectionManagementToFirst()
        }else if(this.sysType == 10){
          // OA办公
          this.addIndexOAofficeToFirst();
        }else if(this.sysType == 11){
          // 客服热线
          this.addIndexHotlineToFirst();
        }else if(this.sysType == 12){
          // DMA
          this.addIndexDMAToFirst();
        }else if(this.sysType == 13){
          // 通知中心
          this.addIndexNoticeToFirst();
        }else if(this.sysType == 4){
          // 表务管理
          this.addIndexMeterManagementToFirst();
        }else if(this.sysType == 5){
          // 集中抄表
          this.addIndexCollectToFirst();
        }else {
          this.addIndexToFirst()
        }
      }
    },
    provide() {
        return {
            closeCurrent: this.closeCurrent,
            onBackNeeds: (type) => {
                this.remove(this.activePage,type)
            }
        }
    },
  }
</script>

<style lang="less">

  /*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  /*美化弹出Tab样式*/
  .ant-tabs-nav-container {
    margin-top: 4px;
  }

  /* 修改 ant-tabs 样式 */
  .tab-layout-tabs.ant-tabs {
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
    background-color: white;
    padding: 0 20px;

    .ant-tabs-bar {
      margin: 4px 0 0;
      border: none;
    }

  }

  .ant-tabs {

    &.ant-tabs-card .ant-tabs-tab {

      padding: 0 24px !important;
      background-color: white !important;
      margin-right: 10px !important;

      .ant-tabs-close-x {
        width: 12px !important;
        height: 12px !important;
        opacity: 0 !important;
        cursor: pointer !important;
        font-size: 12px !important;
        margin: 0 !important;
        position: absolute;
        top: 36%;
        right: 6px;
      }

      &:hover .ant-tabs-close-x {
        opacity: 1 !important;
      }

    }

  }

  .ant-tabs.ant-tabs-card > .ant-tabs-bar {
    .ant-tabs-tab {
      border: none !important;
      border-bottom: 1px solid transparent !important;
    }
    .ant-tabs-tab-active {
      border-color: @primary-color!important;
    }
  }


</style>